export default "__VITE_ASSET__vePhpEWx__"